import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { fetchProject } from '../hooks/projectService';
import { setProject, setStatus, setError, selectProject, selectStatus, selectError } from "../features/project/projectSlice";
import { useSingleProject } from '../hooks/useSingleProject';
import { useProjectHistory } from '../hooks/useProjectHistory';

function History() {


  const { projectId } = useParams();
  const { isLoading, isError, error, data } = useProjectHistory(projectId);
  console.log("data to check", data);





 
  const dispatch = useDispatch();

//   useEffect(() => {
//     if (isLoading) {
//       console.log("Dispatching loading status");
//       dispatch(setStatus('loading'));
//     }
//   }, [isLoading, dispatch]);

  useEffect(() => {
    // console.log("Component updated with new state:", { project, status, error });
  }, [data, isLoading, error]);

  // console.log("Component state:", { project, status, error, isLoading, isError });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>
      <p>Error: {error.message}</p>
    <p>Status: {error.response?.status}</p>
    </div>;
  }

  return (
    <div className="container-fluid p-3" style={{backgroundColor:'#F9FAFB', borderRadius:10, color:'#000', overflowY:'auto', maxHeight:'68vh'}}>
      <h3>History</h3> 

      {/* <div> */}
      
    
      {data.history && data.history.length > 0 ?  (
        data.history.map((item, index) => {
          const formattedDate = new Date(item.timestamp).toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
          });

          return (
            <p key={index}>
              {formattedDate} &nbsp; | &nbsp; {item.username} &nbsp; | &nbsp; {item.taskDetails?.name} &nbsp; | &nbsp; {item.action}
            </p>
          );
        })
      )  : (
      <p>No history available</p>
    )}
    
  </div>
  )
}

export default History